import { render, staticRenderFns } from "./DomainEventDefinition.vue?vue&type=template&id=55197037&scoped=true&"
import script from "./DomainEventDefinition.vue?vue&type=script&lang=js&"
export * from "./DomainEventDefinition.vue?vue&type=script&lang=js&"
import style0 from "./DomainEventDefinition.vue?vue&type=style&index=0&id=55197037&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55197037",
  null
  
)

export default component.exports